// copy
export const copy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/core/utils/copy.js